import React, { useMemo } from 'react';
import { ColumnInfo, ColumnType } from '@/Types';
import { FormInput } from '@/Components/Controls/Input/FormInput';
import { DocumentInfoForPrintModel } from '@/Models/DocumentInfoModel';
import { useLocalization } from '@/Hooks';
import { documentPrintModalActions } from '@/ModalWindows/DocumentPrintModal/services/reducer';
import { useDispatch } from 'react-redux';

export function useDocumentPrintTableColumnInfo() {
  const dispatch = useDispatch();

  const {
    modalWindows: {
      documentPrintModal: { Columns },
    },
  } = useLocalization();

  const onCountCopyChanged = (row: DocumentInfoForPrintModel, value: number) => {
    dispatch(
      documentPrintModalActions.setDocumentNumberCountCopy({
        guid: row.documentNumber,
        count: value,
      }),
    );
  };

  const columnInfos: ColumnInfo<DocumentInfoForPrintModel>[] = useMemo(
    () => [
      {
        columnType: ColumnType.String,
        fieldName: 'countCopy',
        headerText: Columns.CountCopy,
        alignment: 'center',
        width: '80px',
        render: (rowData) => (
          <FormInput
            name={'countCopy'}
            valueForSet={rowData.countCopy}
            type={'number'}
            min={1}
            max={10}
            onChange={(val) => {
              onCountCopyChanged(rowData, Number(val));
            }}
          />
        ),
      },
      {
        columnType: ColumnType.String,
        fieldName: 'documentNumber',
        alignment: 'left',
        headerText: Columns.DocumentNumber,
      },
      {
        columnType: ColumnType.Date,
        fieldName: 'fileDateCreated',
        alignment: 'left',
        headerText: Columns.CreatedDate,
      },
      {
        columnType: ColumnType.Date,
        fieldName: 'documentDate',
        alignment: 'left',
        headerText: Columns.DocumentDate,
      },
    ],
    [Columns],
  );

  return columnInfos;
}
